import React from "react";
import {useAppSelector} from "../../app/hooks";
import {isBotThinkingSelector} from "../chatbotSlice";

export const Thinking: React.FC = () => {

    const isBotThinking = useAppSelector(isBotThinkingSelector);

    if (isBotThinking) {
        return <div className="mt-4 relative self-start w-full">
            <div className="flex flex-row justify-between">
                <div className="flex flex-col items-start">
                    <div
                        className="rounded-xl border-2 text-gray-900 py-4 px-3 items-center bg-white">
                        <div className="flex space-x-2 justify-center">
                            <div
                                className="w-2 h-2 bg-gray-500 rounded-full animate-bounce"
                                style={{animationDelay: "0.0s"}}
                            ></div>
                            <div
                                className="w-2 h-2 bg-gray-500 rounded-full animate-bounce"
                                style={{animationDelay: "0.2s"}}
                            ></div>
                            <div
                                className="w-2 h-2 bg-gray-500 rounded-full animate-bounce"
                                style={{animationDelay: "0.4s"}}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    } else {
        return <></>
    }
}
